import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

// Components
import { ButtonV2, Link } from '@zola/zola-ui';

// Actions
import { hideModal } from '../../../../actions/ModalActions';

// Images
import StartGuestListImage from '../../../../assets/images/website/rsvp/rsvp-start-guest-list.png';

// Styles
import './StartGuestListModal.less';

const StartGuestListModal = ({ closeStartGuestListModal, showGotItTooltip }) => {
  return (
    <div className="start-guest-list__modal">
      <div className="modal__header">
        <h3 className="modal__title">Want to let guests RSVP online?</h3>
        <div className="modal__dek">
          Build your guest list, so you can track RSVPs, meal choices, and more for all your events.
        </div>
      </div>
      <div className="modal__body">
        <div className="modal__image">
          <img alt="Track RSVPs with guest list manager on Zola" src={StartGuestListImage} />
        </div>
        <div className="modal__buttons">
          <Link
            role="button"
            onClick={() => {
              closeStartGuestListModal();
              showGotItTooltip();
            }}
          >
            Do This Later
          </Link>
          <ButtonV2 onClick={() => browserHistory.push('/wedding/manage/guests')}>
            Add Guests
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  closeStartGuestListModal: () => dispatch(hideModal()),
});

StartGuestListModal.propTypes = {
  closeStartGuestListModal: PropTypes.func,
  showGotItTooltip: PropTypes.func,
};

StartGuestListModal.propTypes = {
  closeStartGuestListModal: () => {},
  showGotItTooltip: () => {},
};

export default connect(null, mapDispatchToProps)(StartGuestListModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/StartGuestListModal/StartGuestListModal.jsx